import React from "react";
import {TableCell, TableRow} from "../CourierStatsWidget.styles";
import {ClickableSpan} from "../../../../pools/poolIntensities/responsiveDataTable/ResponsiveDataTable.styles";

export const PoolIntensitiesTableRows = ({pool, handleCourierTypeClick}) => {
    return (
        <TableRow key={pool._id}>
            <TableCell bold>{pool.name}</TableCell>
            <TableCell align="center">{pool.availableRate} %</TableCell>
            <TableCell align="center">{pool.queuedDeliveryCount}</TableCell>
            <TableCell
                align="center"
                style={{cursor: "pointer"}}
                onClick={() => handleCourierTypeClick(pool, "inSlot")}
            >
                <ClickableSpan
                    data-testid="poolInSlotCouriersCount"
                    data-label={"Slot Seçen Kurye Sayısı:"}
                >
                    {pool.inSlotCouriersCount}
                </ClickableSpan>
            </TableCell>
            <TableCell
                align="center"
                type="unavailable"
                style={{cursor: "pointer"}}
                onClick={() => handleCourierTypeClick(pool, "unAvailable")}
            >
                <ClickableSpan
                    data-testid="poolUnAvailableCouriersCount"
                    data-label={"Meşgul Kurye Sayısı:"}
                >
                    {pool.unAvailableCouriersCount}
                </ClickableSpan>
            </TableCell>
            <TableCell
                align="center"
                type="active"
                style={{cursor: "pointer"}}
                onClick={() => handleCourierTypeClick(pool, "active")}
            >
                <ClickableSpan
                    data-testid="poolActiveCouriersCount"
                    data-label={"Aktif Kurye Sayısı:"}
                >
                    {pool.activeCouriersCount}
                </ClickableSpan>
            </TableCell>
            <TableCell
                align="center"
                type="onDelivery"
                style={{cursor: "pointer"}}
                onClick={() => handleCourierTypeClick(pool, "onDelivery")}
            >
                <ClickableSpan
                    data-testid="poolOnDeliveryCouriersCount"
                    data-label={"Siparişteki Kurye Sayısı:"}
                >
                    {pool.onDeliveryCouriersCount}
                </ClickableSpan>
            </TableCell>
            <TableCell
                align="center"
                type="available"
                style={{cursor: "pointer"}}
                onClick={() => handleCourierTypeClick(pool, "available")}
            >
                <ClickableSpan
                    data-testid="poolAvailableCouriersCount"
                    data-label={"Müsait Kurye Sayısı:"}
                >
                    {pool.availableCouriersCount}
                </ClickableSpan>
            </TableCell>
            <TableCell align="center">{pool.slotLimit}</TableCell>
            <TableCell align="center">{pool.poolCouriersCount}</TableCell>
            <TableCell align="center">{pool.slotRate} %</TableCell>
            <TableCell align="center">
                {pool.integrationType === "dedicated"
                    ? "Dedike"
                    : pool.integrationType === "pool"
                    ? "Havuz"
                    : pool.integrationType === "dedicatedIntegration"
                    ? "Dedike Entegrasyon"
                    : pool.integrationType}
            </TableCell>
            <TableCell align="center">{pool.activeDeliveryCount}</TableCell>
            <TableCell align="center">{pool.deliveredCount}</TableCell>
        </TableRow>
    );
};
